module.exports = __webpack_public_path__ + "img/madrid_toda_la_ciudad.07c0a3a5.jpg";